import { connect } from 'react-redux';
import ConversationComponent from '../components/conversation';
import ConversationActions from '../actions/conversation';

function mapStateToProps(state, props) {
  const active = state.activeConversation.id === props.conversation.id;
  // remove null participants. Rare error but can occur
  const participantsFiltered = props.conversation.participants.filter(p => !!p);
  const users = participantsFiltered.map(participant => {
    return participant.user;
  });

  return {
    conversation: props.conversation,
    users: users,
    active: active,
    readState: props.conversation.currentUserParticipant.read
  };
}

const ConversationContainer = connect(
  mapStateToProps,
  {
    selectLoad: ConversationActions.selectLoad,
    fetchActive: ConversationActions.fetchActive,
    archive: ConversationActions.archive
  }
)(ConversationComponent);

export default ConversationContainer;
